// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    getCostCenterRequest: ['params'],
    getCostCenterSuccess: ['payload'],
    getCostCenterFailure: null,

    createCostCenterRequest: ['payload', 'data'],
    createCostCenterSuccess: ['payload'],
    createCostCenterFailure: null,

    editCostCenter: ['payload'],

    deleteCostCenterRequest: ['params'],
    deleteCostCenterSuccess: ['payload'],
    deleteCostCenterFailure: null,

    updateCostCenterRequest: ['params', 'payload'],
    updateCostCenterSuccess: ['payload'],
    updateCostCenterFailure: null,

    openConfirmationModal: ['payload'],
    closeConfirmationModal: null,

    updateSearch: ['payload'],

    updatePageNumber: ['payload'],
    updatePerPage: ['payload'],

    openCostCenterDrawer: ['payload'],
    closeCostCenterDrawer: null,

    updateFormField: ['payload'],
    resetFormFields: null,
  },
  { prefix: 'COSTCENTER/' },
);

export default Creators;
